import { useCallback, useSyncExternalStore } from 'react';

const STORAGE_KEY = 'jiuyi-favorites';

function readStorage(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

let cache: string[] = readStorage();
const listeners = new Set<() => void>();

function subscribe(callback: () => void) {
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
}

function getSnapshot() {
  return cache;
}

function emit() {
  listeners.forEach((listener) => listener());
}

function write(next: string[]) {
  cache = next;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // ignore storage failures (e.g. private mode)
  }
  emit();
}

export function toggleFavorite(id: string) {
  write(cache.includes(id) ? cache.filter((item) => item !== id) : [...cache, id]);
}

export function useFavorites() {
  const ids = useSyncExternalStore(subscribe, getSnapshot, () => cache);
  const isFavorite = useCallback((id: string) => ids.includes(id), [ids]);
  return { ids, isFavorite, toggle: toggleFavorite };
}